import React from 'react';
import { Progress } from 'tea-component';
import './index.scss';
import SvgIcon from '@/pages/home/components/SvgIcon'; 
import CommonBubble from '@home/components/CommonBubble';
import { DBO_V } from '@op/utils/format';
import noDateIcon from '@op/assets/svg/rating_neutral.svg';
import useLanguage from '@op/hooks/useLanguage';

// 带感情色彩 sentiment, 圆环 circle
export default function ProgressContext({
  percent,
  sizeWidth,
  strokeWidth,
  sentiment = false,
  circle = false,
  title,
  text,
  reviewNum = null,
  iconType = 'good-icon',
  strokeColor,
  bubbleTips,
}: any) {
  const { formatMessage } = useLanguage();

  const getColor = () => {
    if (strokeColor) {
      return strokeColor;
    }

    return sentiment && percent <= 50
      ? '#EF5858'
      : sentiment && percent > 50
        ? '#29B569'
        : '#5086F3"';
  };

  return (
    // 不带感情色彩的圆环颜色固定蓝色
    // 带感情色彩的圆环颜色，当%超过50%时圆环为绿色，否则圆环为红色
    <div className="dbo-circleprogress">
      {circle ? (
        <CommonBubble content={bubbleTips}>
          <Progress
            type="circle"
            percent={percent}
            strokeColor={getColor()}
            text={text || percent}
            strokeWidth={strokeWidth ? strokeWidth : 8}
            width={sizeWidth ? sizeWidth : 96}
            className="dbo-circleprogress-main"
          />
        </CommonBubble>
      ) : !iconType ? (
        <span className="dbo-circleprogress-main">
          <img src={noDateIcon}></img>
        </span>
      ) : (
        <SvgIcon className="dbo-circleprogress-main" type={iconType} />
      )}
      <div className="dbo-circleprogress-flex">
        <div className="dbo-circleprogress-title">{title}</div>
        {!DBO_V.is_empty(reviewNum) ? (
          <div className="dbo-circleprogress-text">
            {DBO_V.reviews(reviewNum, 2, '0')}{' '}
            {formatMessage({ id: 'Reviews-1' })}
          </div>
        ) : null}
      </div>
    </div>
  );
}
